import {useCallback, useState} from 'react';
import {BackHandler} from 'react-native';
import {CardGatewayCallbacks, ChargeCardFn} from './types';
import {useCardProcessingPolling} from '../hooks/useCardProcessingPolling';

type Options = CardGatewayCallbacks & {
  chargeCard: ChargeCardFn;
  onRemoveBaratinhas: () => void;
};

export function useLegacyGateway({
  chargeCard,
  onSuccess,
  onError,
  onRemoveBaratinhas,
}: Options) {
  const [isPaying, setIsPaying] = useState(false);

  const wrappedOnSuccess = useCallback(() => {
    onRemoveBaratinhas();
    onSuccess();
  }, [onRemoveBaratinhas, onSuccess]);

  const {startPolling, isPolling, clearPolling} = useCardProcessingPolling({
    onSuccess: wrappedOnSuccess,
    onError,
  });

  const pay = useCallback(
    async (cvc: string) => {
      setIsPaying(true);
      BackHandler.addEventListener('hardwareBackPress', () => true);

      try {
        const data = await chargeCard({cvc, three_ds_provider: null, is3ds: false});

        if (data?.processando) {
          startPolling({ compra_id: data.compra_id });
          return;
        }

        wrappedOnSuccess();
      } catch (err: any) {
        onError(err?.response?.data?.msg);
      } finally {
        setIsPaying(false);
      }
    },
    [chargeCard, wrappedOnSuccess, onError, startPolling],
  );

  return {pay, isPaying, isPolling, clearPolling};
}
